import { render, staticRenderFns } from "./mediaCenter.vue?vue&type=template&id=1aafbdc6&scoped=true&"
import script from "./mediaCenter.vue?vue&type=script&lang=js&"
export * from "./mediaCenter.vue?vue&type=script&lang=js&"
import style0 from "./mediaCenter.vue?vue&type=style&index=0&id=1aafbdc6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aafbdc6",
  null
  
)

export default component.exports